import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_np5ktd5ja2: FaireBrandEntity = {
  token: "b_np5ktd5ja2",
  type: "brand",
  name: "Burt's Bees Baby",
  avatarUrl:
    "https://cdn.faire.com/fastly/09c49069de9a752dc7c52994f705d57ef060bfb8b11a48ac869f9d8775977bb2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a74c0386f15fe1e9260894bba31729569aa86eb8f7e2545a7d9d208230da3e7b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/09c49069de9a752dc7c52994f705d57ef060bfb8b11a48ac869f9d8775977bb2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a74c0386f15fe1e9260894bba31729569aa86eb8f7e2545a7d9d208230da3e7b.jpeg",
  location: "Fairfield, CT, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 91,
  isTopShop: true,
  isInsider: true,
  description:
    "At Burt’s Bees Baby, we are dedicated to providing high-quality, sustainable, and natural products for your little ones. Our baby clothes are crafted with the gentlest ingredients, made from organic cotton and designed for comfort and safety. We believe in protecting both your baby and the planet, which is why we use eco-friendly materials and packaging. With Burt’s Bees Baby, you can trust that your baby’s well-being is always our top priority.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:16.256Z",
    importedBy: "entity-db-cli",
  },
};
